import { render, staticRenderFns } from "./qitapeizhi.vue?vue&type=template&id=2c9792c0&"
import script from "./qitapeizhi.vue?vue&type=script&lang=js&"
export * from "./qitapeizhi.vue?vue&type=script&lang=js&"
import style0 from "./qitapeizhi.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports